import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { Duration as LuxonDuration } from 'luxon';
import { Translate as translate } from '@wsb/vnext-widget-content-translate';

export default class Duration extends Component {
  render() {
    const { Element } = UX2.Element;
    const { duration, staticContent } = this.props;

    const interpolate = translate(staticContent);

    // Requires ISO8601 duration
    const luxonDuration = LuxonDuration.fromISO(duration);
    const formattedDuration = [];

    if (luxonDuration.days === 1) {
      formattedDuration.push(
        <Fragment key='24hr'>
          { interpolate('durationHours', { duration: 24 }) }
        </Fragment>
      );
    } else if (luxonDuration.hours > 0) {
      formattedDuration.push(
        <Fragment key='hr'>
          { interpolate('durationHours', { duration: luxonDuration.hours }) }
        </Fragment>
      );
    }

    if ((luxonDuration.days === 1 || luxonDuration.hours > 0) && (luxonDuration.minutes > 1)) {
      formattedDuration.push(' ');
    }

    if (luxonDuration.minutes > 1) {
      formattedDuration.push(
        <Fragment key='min'>
          { interpolate('durationMinutes', { duration: luxonDuration.minutes }) }
        </Fragment>
      );
    }

    return (
      <Element style={{ whiteSpace: 'nowrap' }}>
        { formattedDuration }
      </Element>
    );
  }
}

Duration.propTypes = {
  duration: PropTypes.string,
  durationStyles: PropTypes.object,
  staticContent: PropTypes.object.isRequired
};
